/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import type { ShopProduct } from "@farmlands/commerce";

import { generateImageUrl } from "../../../util/helpers";
import type { Product } from "../../products/storage/types";

// Maps the new shop product to the old product type for use in old modals
export const mapShopProductToProduct = (
  shopProduct: ShopProduct,
  selectedProductId?: number
): Product => {
  const masterProductId = Number(shopProduct.masterProductId) || 0;
  const itemNumber = shopProduct.itemNumber ?? "";
  const productId =
    selectedProductId ??
    shopProduct.selectedProductId ??
    shopProduct.variants[0]?.productId ??
    masterProductId;

  return {
    productId,
    masterProductId,
    itemNumber,
    name: shopProduct.name,
    description: shopProduct.onlineShortDescription ?? shopProduct.onlineLongDescription ?? "",
    category: shopProduct.category ?? "Miscellaneous",
    subCategory: shopProduct.subCategory,
    basePriceExcGst: shopProduct.basePriceExcGst ?? 0,
    basePriceIncGst: 0,
    discountedPriceExcGst: shopProduct.discountedPriceExcGst ?? 0,
    discountedPriceIncGst: shopProduct.discountedPriceIncGst ?? 0,
    lifeCycleState: shopProduct.lifecycle || null,
    isPriceNegotiable: shopProduct.priceNegotiable,
    hasVariants: shopProduct.hasVariants,
    stockAvailability: shopProduct.stockAvailability,
    stockAvailabilities: shopProduct.availabilities,
    promotions: shopProduct.promotions,
    priceBreaks: shopProduct.priceBreaks,
    orders: [],
    imageUrl: itemNumber ? generateImageUrl(itemNumber) : undefined,
  };
};
